import React, { useState } from 'react';
import { Typography, Box, Stack } from '@mui/material';
import defaultArtistThumbnail from '../../assets/default_artist_thumbnail.svg';

const ArtistSimpleCard = ({ name, artistImageUrl }) => {
  const [imageError, setImageError] = useState(false);

  const handleError = () => {
    if (!imageError) {
      setImageError(true);
    }
  };

  return (
    <Stack
      spacing={{ xs: 2, md: 2.5, lg: 2 }}
      sx={{
        width: { xs: '58%', md: '28%', lg: '20%' },
        minWidth: { xs: 200, md: 240, lg: 280 },
        maxWidth: { xs: 300, md: 340, lg: 380 },
        m: 'auto',
        alignItems: 'center',
      }}
    >
      <Box
        component="img"
        src={imageError || !artistImageUrl ? defaultArtistThumbnail : artistImageUrl}
        alt={name}
        loading="lazy"
        onError={handleError}
        sx={{
          width: '100%',
          aspectRatio: '1 / 1',
          objectFit: 'cover',
        }}
      />
      <Typography
        fontSize={{ xs: 16, md: 18, lg: 24 }}
        fontWeight={700}
        sx={{
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          lineHeight: '1.5',
        }}
      >
        {name}
      </Typography>
    </Stack>
  );
};

export default ArtistSimpleCard;
